export default __webpack_public_path__ + "02b76c263b260d881d8832c7d8dfe3f7.png";